// extracted by mini-css-extract-plugin
export default {"wrapper":"Ship_wrapper__N+wek","ship-method":"Ship_ship-method__kBx-s","method":"Ship_method__AfwqT","time":"Ship_time__wktHj","cost":"Ship_cost__dCmle"};